import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";

import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "semantic-ui-react";
import { yup } from "utils";

import Form from "components/Form";

function CouponForm({ error, loading, onApply, children }) {
  const formProps = useForm({
    mode: "onChange",
    resolver: yupResolver(yup.object().shape({ name: yup.string() })),
  });

  const { watch, setError, clearErrors } = formProps;
  const name = watch("name");

  useEffect(() => {
    if (error && !loading) {
      setError("name", { type: "manual", message: error });
    } else if (!name) {
      clearErrors("name");
    }
  }, [name, loading, error, setError, clearErrors]);

  return (
    <Form id="couponForm" {...formProps} onSubmit={onApply}>
      <div style={{ margin: "20px 0 40px 0" }}>
        <Form.Input
          name="name"
          defaultValue=""
          placeholder="Enter a coupon code"
          disabled={loading}
          action={
            <React.Fragment>
              <Button disabled={!name || loading} loading={loading}>
                Apply
              </Button>
              {children}
            </React.Fragment>
          }
        />
      </div>
    </Form>
  );
}

CouponForm.propTypes = {
  error: PropTypes.string,
  loading: PropTypes.bool,
  onApply: PropTypes.func.isRequired,
  children: PropTypes.node,
};

CouponForm.defaultProps = {
  error: "",
  loading: false,
  children: undefined,
};

export default CouponForm;
